import type { ActiveGuideQuest } from "@yjsgames/guide-quest";
import { BigNumber } from "@yjsgames/bignumber";
import { REWARD_BUNDLES } from "../data/rewardData.js";
import type { RewardBundle, RewardSpec } from "../models/RewardSpec.js";
import { t } from "../i18n/i18n.js";
import { formatBig } from "./formatNumber.js";
import type { GuideQuestPanelData } from "./GuideQuestPanel.js";

function rewardAmountText(spec: RewardSpec): string {
  switch (spec.kind) {
    case "gold":
      return formatBig(BigNumber.fromString(spec.amount));
    case "diamond":
      return formatBig(BigNumber.fromString(spec.amount));
    case "upgradeStone":
      return String(spec.amount);
    case "rebirthPoint":
      return String(spec.amount);
    case "randomModule":
      return `x${spec.count}`;
    case "artifact":
      return String(spec.amount);
  }
}

function rewardIconKey(spec: RewardSpec): string {
  switch (spec.kind) {
    case "gold":
      return "icon_gold";
    case "diamond":
      return "icon_diamond";
    case "upgradeStone":
      return "icon_upgrade_stone";
    case "rebirthPoint":
      return "icon_rebirth_point";
    case "randomModule":
      return "icon_tab_codex";
    case "artifact":
      return "icon_tab_relic";
  }
}

export function guideQuestRewardButton(bundle: RewardBundle | undefined): {
  readonly iconKey: string;
  readonly amountText: string;
} {
  const first = bundle?.[0];
  if (!first) return { iconKey: "icon_gold", amountText: "" };
  return { iconKey: rewardIconKey(first), amountText: rewardAmountText(first) };
}

export function buildGuideQuestPanelData(active: ActiveGuideQuest | null): GuideQuestPanelData {
  if (!active) {
    return {
      visible: false,
      title: "",
      description: "",
      progressText: "",
      rewardIconKey: "icon_gold",
      rewardAmountText: "",
      completed: false,
      allDone: true,
    };
  }
  const def = active.definition;
  const reward = guideQuestRewardButton(REWARD_BUNDLES[def.rewardBundleId]);
  return {
    visible: true,
    title: t(def.titleKey),
    description: t(def.descriptionKey),
    progressText: t("guideQuest.progress", {
      current: Math.min(active.progress, active.targetCount),
      target: active.targetCount,
    }),
    rewardIconKey: reward.iconKey,
    rewardAmountText: reward.amountText,
    completed: active.completed,
    allDone: false,
  };
}
